import type { HttpOptions } from './app/package/base/service/http/http-service';

export const STORAGE_KEY_HAS_USER_LOGGED_IN_ONCE = 'has-user-logged-in-once-v1';

// Slug of the often-searched lane/category (URL: kategorie/oft-gesucht). Its
// games are served by the DS-personalised often-searched endpoint, not the
// generic category filter.
export const OFTEN_SEARCHED_CATEGORY_SLUG = 'oft-gesucht';
export { LOCAL_STORAGE_KEY_DISABLE_LOGGER, LOCAL_STORAGE_STARTUP_LOG_LEVEL } from './priority-constants';
export const LOCAL_STORAGE_KEY_COMPLIANCE_TEST = 'is-compliance-disabled';
export const LOCAL_STORAGE_KEY_DEACTIVATION_OVERRIDE = 'deactivation-override';
export const STORAGE_KEY_IS_VIDEO_PAUSED = 'banner-video-paused';
export const STORAGE_KEY_IS_VIDEO_MUTED = 'banner-video-muted';
export const LOCAL_STORAGE_KEY_ONBOARDING_OVERRIDE = 'onboarding-override';
export const LOCAL_STORAGE_KEY_RENDERSERVICE_DEBUGGER = 'show-renderservice-debugger';
export const LOCAL_STORAGE_KEY_TRACKED_MINI_GAMES = 'mini-game-tracked-ids';
export const LOCAL_STORAGE_KEY_LOGIN_PROMO_SEEN_IDS = 'login-promo-seen-ids';
export const LOCAL_STORAGE_KEY_CRASH_DETECTOR = 'crash-detector-enabled';
export const LOCAL_STORAGE_KEY_NOTIFICATION_PROMPT_STATE = 'notification-prompt-state';
export const LOCAL_STORAGE_KEY_USE_5G_MINI_GAME = 'use-5g-mini-game';
export const LOCAL_STORAGE_KEY_FORCE_5G_MINI_GAME = 'force-5g-mini-game-available';
export const LOCAL_STORAGE_KEY_5G_WHEEL_THEME_OVERRIDE = '5g-wheel-theme-override';
export const LOCAL_STORAGE_KEY_HAS_DEPOSIT_OVERRIDE = 'has-deposit-override';

// http service
export const REPORT_4XX__RETRY_REPORT_500: HttpOptions = {
  retryOptions: { errorCodesToRetry: ['5..'] },
};

export const REPORT_4XX_5XX: HttpOptions = {
  retryOptions: { errorCodesToRetry: [] },
};

export const SESSION_STORAGE_KEY_IS_REDIRECTED_FROM_GAME_PAGE = 'is-redirected-from-game-page';
export const SESSION_STORAGE_KEY_DISABLE_GTM = 'disable-gtm';
export const SESSION_STORAGE_KEY_DISABLE_MULTITAB = 'disable-multitab';
export const SESSION_STORAGE_KEY_DISABLE_ABTASTY = 'disable-abtasty';
export const SESSION_STORAGE_KEY_DISABLE_CASSIE = 'disable-cassie';
export const SESSION_STORAGE_KEY_DISABLE_MINI_GAME_INTERCEPT = 'disable-mini-game-intercept';
export const SESSION_STORAGE_KEY_IFRAME_COUNTER = 'iframe-counter-enabled';
export const SESSION_STORAGE_KEY_SCRIPT_COUNTER = 'script-counter-enabled';
export const SESSION_STORAGE_KEY_CRASH_FLAG = 'crash-detector-flag';
export const SESSION_STORAGE_KEY_CRASH_COUNT = 'crash-detector-count';
// Cashier payment session started in this tab; marks the provider's return.
export const SESSION_STORAGE_KEY_CASHIER_PAYMENT_IN_PROGRESS = 'cashier-payment-in-progress';
// One-shot guard against an SSO auto-login recovery redirect looping.
export const SESSION_STORAGE_KEY_SSO_LOGIN_REDIRECT_ATTEMPTED = 'sso-login-redirect-attempted';

// SH state disclaimer modal
export const STATE_DISCLAIMER_MODAL_CLOSED = 'state-disclaimer-modal-closed';

// Accessibility panel
export const LOCAL_STORAGE_KEY_A11Y_HIGH_CONTRAST = 'a11y-high-contrast';
export const LOCAL_STORAGE_KEY_A11Y_FONT_SCALE = 'a11y-font-scale';
export const LOCAL_STORAGE_KEY_A11Y_LOW_VISION = 'a11y-low-vision';
export const LOCAL_STORAGE_KEY_A11Y_COLOR_BLIND = 'a11y-color-blind';
export const LOCAL_STORAGE_KEY_A11Y_REDUCE_MOTION = 'a11y-reduce-motion';
export const LOCAL_STORAGE_KEY_A11Y_DYSLEXIA_FONT = 'a11y-dyslexia-font';
export const LOCAL_STORAGE_KEY_A11Y_FOCUS_HIGHLIGHT = 'a11y-focus-highlight';
export const LOCAL_STORAGE_KEY_A11Y_CAPTIONS = 'a11y-captions';
export const LOCAL_STORAGE_KEY_A11Y_FAB_HIDDEN = 'a11y-fab-hidden';
